import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const RENTAL_APPLICATION_SOURCES_B = [
  {
    sourceId: "rental-application-source-costs",
    topicId: "rental-application",
    title: "Costs at the start of a residential tenancy",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/costs-at-start-of-a-residential-tenancy",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 application 승인 후 holding fee, bond·rent와 허용되지 않는 background-check·application 비용을 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW rental application·tenancy 시작 단계의 허용·금지 비용",
    followUp: "지급 전 application approval, payment purpose, receipt와 current statutory limit 확인",
  },
  {
    sourceId: "rental-application-source-start-documents",
    topicId: "rental-application",
    title: "Information a tenant should get at the start of a tenancy",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/information-a-tenant-should-get-at-start-of-a-tenancy",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 signing·move-in 전 tenant information statement, proposed agreement, condition report, strata by-laws와 RBO invitation 제공 의무를 확인",
    reviewStatus: "live_verified",
    claimScope: "application 승인 후 lease 서명 전에 받아야 할 NSW tenancy documents",
    followUp: "서명 전에 모든 documents, attachments, by-laws와 bond invitation의 parties·address 일치 확인",
  },
  {
    sourceId: "rental-application-source-material-facts",
    topicId: "rental-application",
    title: "What tenants need to be told about a rental property",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/what-tenants-need-to-be-told-about-a-rental-property",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 signing 전 sale, mortgagee possession, strata renewal와 prescribed material facts disclosure를 확인",
    reviewStatus: "live_verified",
    claimScope: "prospective tenant의 결정에 영향을 줄 NSW property disclosures",
    followUp: "property-specific material facts, proposed sale·strata information과 written disclosure를 서명 직전 확인",
  },
  {
    sourceId: "rental-application-source-agreement",
    topicId: "rental-application",
    title: "Standard residential tenancy agreement",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rental-forms-surveys-and-data/resources/standard-residential-tenancy-agreement",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Fair Trading 공식 standard agreement에서 binding terms, signed copy와 condition report·Tenant Information Statement attachments를 확인",
    reviewStatus: "live_verified",
    claimScope: "성공한 NSW rental application 이후 standard lease 검토와 서명",
    followUp: "advertisement·offer와 agreement의 rent, term, occupants, inclusions·special terms 일치 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of RENTAL_APPLICATION_SOURCES_B) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
